module.exports = __webpack_public_path__ + "img/player-heart-icon.1cb6167b.svg";